import React, { Component } from 'react';
import { isMobileOnly } from 'react-device-detect';
// import { Link } from 'react-router-dom';
import { Body, Title } from '@vds/typography';
import { Button, TextLink } from '@vds/buttons';
import Icon from '@vds/icons';
import './NavHeader.css';
// import FloatingCart from '../FloatingCart/FloatingCart';
// import DynamicCart from '../FloatingCart/DynamicCart/DynamicCart';
import BundleFloatingCart from '../FloatingCart/BundleFloatingCart';
import { StickyHeader } from "@vds/layout";
import styled from 'styled-components';
import { connect } from 'react-redux';
import { setNavPrice, setCheckOutProgress, postUIEventLog,saveBusinessInfo, enableRouterNotification, enablePhoneNotification, enableEquipmentNotification, setRouterErrorNotification } from '../../Pages/CustomizeOrder/containers/actions';
// import { getCartInfoMonthValues } from '../FloatingCart/FloatingCartUtils';
import * as SiteAnalytics from '../../sitecatalyst';
import { Loader } from '@vds/loaders';
// import { Tooltip } from '@vds/tooltips';
import { showSpinner } from '../../Pages/AddressValidationPage/containers/action';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { spacers } from '@vds-core/theme';
import { BUNDLE } from '../../containers/bundleConversionUtils';
import Countdown from '../../Pages/Countdown/Countdown';
import {HolidayOfferBanner} from '../HolidayOffer/CountDown'
import BundleFloatingCartNew from '../FloatingCart/BundleFloadingCartNew';
import { resetCheckoutNew, setCompletedSections } from '../../Pages/CheckoutNew/ducks/action';
import { updateNextButtonCC } from '../../Pages/Checkout/containers/action';
import { VCG_CMP } from "../../Pages/CustomizeOrder/containers/constants"
import VcgBannerHeader from "./VcgBannerHeader"
import { CheckAEMBoolValue } from '../CommonPlanTile/CommonPlanTile';

const NavStickyHeader = styled(StickyHeader)`
`;

const MarginSpacerL = styled.div`
	margin-top: ${spacers.medium} !important;
	margin-bottom: ${spacers.extraLarge} !important;
`;

const RedirectModal = styled(Modal)`
height: auto;
min-width:40rem;
@media only screen and (max-width: 600px) {
    position: absolute;
    top: 10px;
    right:10px;
    left:10px;
    width: 90%;
    height: 97vh;
	min-width:95vw;
    > div:first-child {
        padding:2px;
    }
}
> div:first-child {overflow:hidden}
`;

const ButtonWrapper = styled.div`
  display: flex;
	button {
		margin-right:2rem;
		margin-bottom: 2rem;
		width: 250px;
	}
	@media only screen and (max-width: 600px) {
		display: block;
	}
  }
`;

const ChangeAddressModal = (props) => {
	const btnHandler = (isRedirect) => {
		if (isRedirect) {
			props.history.push(props.redirectUrl);
		}
		props.closeModal()
	}

	return (
		<RedirectModal
			ariaLabel=""
			opened={true}
			disableOutsideClick={true}
			onOpenedChange={(status) => {
				if (!status) {
					props.closeModal();
				}
			}}>
			<ModalTitle>
				<Title size="small" primitive="h2">Change address?</Title>
			</ModalTitle>
			<ModalBody>
				<MarginSpacerL>
					<Body size="large" primitive="h3">
						By clicking "Yes, change address", you will be taken to the address entry page to restart the creation of your shopping cart. Do you wish to continue changing your address?
				</Body>
				</MarginSpacerL>
				<div>
					<ButtonWrapper>
						<Button onClick={() => btnHandler(true)}  >Yes, change address</Button>
						<Button secondary onClick={() => btnHandler(false)} >No, keep address</Button>
					</ButtonWrapper>

				</div>
			</ModalBody>
		</RedirectModal>
	);
}

export const RenderAddress = ({ globalScope, props, changeLinkHandler }) => {

	if (!globalScope) return null;
	if (!globalScope.Address) return null;
	let address = globalScope.Address || [];
	let street = '';
	let zipCode = '';
	const redirectUrl = window.location?.search?.indexOf("frombroadbandanywhere") > -1 ? "/foryoursmallbiz/internet" : "/";
	if (isMobileOnly && globalScope.Address) {
		const addressArr = globalScope.Address.split(',')
		street = <div className="street">{addressArr[0] + ','}</div>
		zipCode = <div className="city">{addressArr.slice(-2).join(', ')}</div>
		address = <> {street} {zipCode}</>
	} else {
		address = `${globalScope.Address} ${globalScope.zipCode || ''}`;
	}
	return (
		<div className={`${isMobileOnly ? "Left-Section mobile" : 'Left-Section desktop'}`}>
			<div className="Address">

				{/* {isMobileOnly &&<Body size="large" primitive="p"> {globalScope.Address}{' '}{globalScope.zipCode || ''} <Link to='/'>
					<span className="change-address">Change</span>
				</Link></Body>} */}
				{window.location.pathname.indexOf("/out-of-franchise") > -1 ?
					<> <Body size="large" primitive="p">
						{globalScope.Address + ", " + `${globalScope.unit && globalScope.unit !== "I don't live in a unit" ? globalScope.unit + ', ' : ''}` + globalScope.zipCode}

						{/* {globalScope.Address.split(',')[1]}{','}{globalScope.Address.split(',')[2]? globalScope.Address.split(',')[2]:globalScope.zipCode} */}
						{/* <Link className="change-address" to={redirectUrl}>
							<span >Change</span>
						</Link> */}
						<TextLink
							className="change-address"
							type="standAlone"
							inverted={false}
							disabled={false}
							onClick={() => changeLinkHandler(redirectUrl)}>
							Change
						</TextLink>
					</Body>
					</>
					:

					globalScope.Address &&
					<><Body size="large" primitive="p">{globalScope.Address.split(',')[0]}{','}</Body>
						<Body size="large" primitive="p">
							{globalScope.Address?.replace(globalScope.Address.split(',')[0] + ',', '')}
							{globalScope.Address.indexOf(globalScope.Zip || '') > -1 ? '' : ` ${globalScope.Zip || ''}`}
							{/* <Link className="change-address" to={redirectUrl}>
								<span >Change</span>
							</Link> */}
							<TextLink
								className="change-address"
								type="standAlone"
								inverted={false}
								disabled={false}
								onClick={() => changeLinkHandler(redirectUrl)}>
								Change
							</TextLink>
						</Body>
					</>

				}
			</div>
			<div className="Change-link">

			</div>
			{/* {props?.phoneNumber && (props.history?.location?.pathname == "/customize-order" || props.history?.location?.pathname == "/checkout") && <div>
				<Body size="large" primitive="span">{props.phoneNumber}</Body> */}
				{/* <Body size="large" primitive="span"><span className="offer-text">{globalScope?.IsB2BMTN == "B" ? "Your number qualifies for joint offer" : "Your number does not qualify for the joint offer"}</span></Body>
				<div className="notification-toltip">
					{globalScope?.IsB2BMTN == "B" ? <Tooltip size="small" className="tooltip">
						<h4>Requirements to qualify for joint Wireless and Fios offer</h4>To recieve the discount, you must select the Fios Gigabit Connection.
					</Tooltip> :
						<Tooltip size="small" className="tooltip">
							<h4>Requirements to qualify for joint Wireless and Fios offer</h4>To qualify, you need an eligible 4G LTE smartphone and a five-line account minimum in your Verizon Wireless Business Unlimited Plus Plan.
				</Tooltip>
					}
				</div> */}
			{/* </div>
			} */}
		</div>
	)
}
class NavHeader extends Component {
	constructor(props) {
		super(props);		
		this.state = {
			// opened :false,
			opened: !isMobileOnly && props?.history?.location?.pathname?.includes("/checkout") ? true:false,
			priceBlockX: 0,
			stickyPos: isMobileOnly ? 65 : 98,
			showRedirectModal: false
		};
	}

	// componentDidMount(){
	// 	let dd=  this.props;
	// 	this.setState({opened:true})
	// }
	componentWillReceiveProps(props) {
		const { enableFeaturesBDVW, enableEquipmentBDVW, enableWebexSection, bdvwFeaturesVisited } = props;
	}
	toggleBox = () => {
		if (this.props.getFloatCartResponse && this.props.getFloatCartResponse.planDetails !== null) {
			this.props.saveBusinessInfo(false);
			const { opened } = this.state;
			this.setState({
				opened: !opened
			});
			if (opened) {
				SiteAnalytics.trackCartClicked({}, this.props.getFloatCartResponse);
			}
			this.props.postUIEventLog({ eventType: 'log', eventName: "Button Click", sectionName: `Floating Cart`, log: `Floating Cart ${!opened ? 'opened' : 'closed'}` });
		}
	};

	componentDidUpdate() {
		if(this.state.opened && this.props.isSaveBusinessInfo)
		{
			this.setState({opened : false})
		}
		
			}

			

	getPhonePrice = () => {
		const { customizeOrder } = this.props;
		const phoneValue = customizeOrder && customizeOrder?.length && Object.keys(customizeOrder[0].selectedDetails)?.length
			&& customizeOrder[0].selectedDetails.selectedPrice;
		return phoneValue;
	};
	getPowerReserveValue = () => {
		const { customizeOrder } = this.props;
		const powerReserveValue = customizeOrder && customizeOrder?.length && Object.keys(customizeOrder[0].selectedDetails)?.length
			&& Object.keys(customizeOrder[1].selectedDetails)?.length < 3 && customizeOrder[5].selectedDetails.value === "Yes" ? 89 : 0;
		return powerReserveValue;
	};
	getStandardPhonePrice = () => {
		const { customizeOrder } = this.props;
		const standardPhonePrice =
			customizeOrder && customizeOrder?.length && Object.keys(customizeOrder[2].selectedDetails)?.length
			&& customizeOrder[2].selectedDetails.selectedPrice;
		return standardPhonePrice;
	};
	getDirectoryListingPrice = () => {
		const { customizeOrder } = this.props;
		const directoryListingPrice =
			customizeOrder && customizeOrder?.length && customizeOrder[4].selectedDetails &&
			Object.keys(customizeOrder[4].selectedDetails)?.length
			&& customizeOrder[4].selectedDetails.selectedPrice;
		// if(!directoryListingPrice) {
		// 	directoryListingPrice = "0";
		// }
		return directoryListingPrice;
	};

	getCartValue = () => {
		const { customizeOrder } = this.props;
		if (customizeOrder) {
			// console.log('customizeOrder[1].selectedDetails- ', customizeOrder)
		}
		let price = 0;
		if (customizeOrder && customizeOrder?.length && customizeOrder[1].selectedDetails && Object.keys(customizeOrder[1].selectedDetails)?.length > 1) {
			customizeOrder[1].selectedDetails.slice(1).forEach(plan => {
				if (customizeOrder[0].selectedDetails?.value === 'Business Digital Voice') {
					price += customizeOrder[0].selectedDetails?.selectedPrice
				} else if (plan?.NewPlanID === '2033437') {
					price += 20;
				} else {
					price += 59;
				}
			})
		}
		return price;
	};

	sumProperty = (arr, type) => {
		return arr ? arr.reduce((total, obj) => {
			if (typeof obj[type] === 'string' && obj.Quantity) {
				return total + Number(obj[type]) * Number(obj.Quantity);
			} else {
				return total;
			}
			return total + obj[type];
		}, 0) : 0;
	};

	calculateEquipment = () => {
		const { customizeOrder } = this.props;
		const deskTop =
			customizeOrder && customizeOrder?.length && Object.keys(customizeOrder[3].selectedDetails)?.length
				? customizeOrder[3].selectedDetails
				: null;
		let totalAmount = deskTop ? this.sumProperty(deskTop.phoneList, 'eachMonthPrice').toFixed(2) : '';
		return Number(totalAmount);
	};
	redirectToSavecart = () => {
		// if (!this.props.emailAddress) {
		window.prevUrl = window.location.pathname;
		const isCheckout = window.prevUrl.search('checkout');
		if (isCheckout !== -1) {
			const VOStatus = this.props.VOStatus;
			this.props.showSpinner(true);
			if ((VOStatus?.toUpperCase() === 'VOFAIL') || (VOStatus?.toUpperCase() === 'VOSUCCESS')) {
				console.log("VO ", VOStatus);
				this.props.showSpinner(false);
			}
		}
		this.props.history.push("/save-cart");
		// } else {
		// this.props.submitSaveCart();
		// }
		if (window?.newrelic?.addPageAction) {
			window.newrelic.addPageAction('SaveCart Button Click', { data: { eventName: 'savecart_button_click' } });
		}
		this.props.postUIEventLog({ eventType: 'log', eventName: "Button Click", sectionName: "Save Cart" });
	};

	componentDidMount() {
		if (this.priceBlock) {
			const leftX = this.priceBlock.getBoundingClientRect().left;
			this.setState({ priceBlockX: leftX });
		}


		window.addEventListener('scroll', this.handleScroll);
	}

	handleScroll = () => {
		// console.log("scroll")
		if (this.stickyNav && isMobileOnly) {
			const getTop = this.stickyNav.getBoundingClientRect().top

		}

	}
	btnHandler = () => {
		if(this.props.enableBDVW&&this.props.servicesInCart!="DATA"?this.props.bdvwFeaturesVisited:true){
		const phoneList = this.props.bdvEquipmentList ? this.props.bdvEquipmentList.phoneList : [];
		const equipmentList = phoneList && phoneList.filter(equipment => equipment.Quantity && Number(equipment.Quantity) > 0 && equipment.updateCart)?.length === 0;
		if((this.props.servicesInCart === BUNDLE.DATA || this.props.servicesInCart === BUNDLE.DATA_BDV || this.props.servicesInCart === BUNDLE.BDV_DATA || 
			this.props.servicesInCart === BUNDLE.DATA_PHONE
		)&&this.props.enableVDS3){
			// if(!this.props.selectedInternetPlanID){
			// 	this.props.enableTheInternetNotification(true)
			// const routerCheck = document.getElementById('internetContinue');
			// routerCheck.scrollIntoView({block: "center", behavior: "smooth"});
			// return;
			// }
			if(this.props.selectedRouter){
			if((this.props.servicesInCart === BUNDLE.DATA_BDV) && !this.props.serviceReqCheck && !this.props.enableBDVW){
				this.props.enablePhoneNotification(true)
				setTimeout(()=>{
				const phoneCheck = document.getElementById('phoneContinue');
				phoneCheck.scrollIntoView({block: "center", behavior: "smooth"});
			},800);
			}else if(this.props.servicesInCart === BUNDLE.DATA_BDV && this.props.serviceReqCheck && equipmentList && !this.props.enableBDVW){
				this.props.enableEquipmentNotification(true)
				setTimeout(()=>{
				const equipmentCheck = document.getElementById('phoneContinue');
				equipmentCheck.scrollIntoView({block: "center", behavior: "smooth"});
			},800);
			}else{
				this.props.resetCheckoutNew()
				this.props.updateNextButtonCC("")
				this.props.setCompletedSections([])
			let path = this.props.enableDigitalLink === 'Y' ? "/save-cart" : '/checkout';
			this.props.history.push(path);
			}
			}else this.props.setRouterErrorNotification(true)
		}
		else{
			// if(!this.props.selectedInternetPlanID && (this.props.servicesInCart === BUNDLE.DATA || this.props.servicesInCart === BUNDLE.DATA_BDV || this.props.servicesInCart === BUNDLE.BDV_DATA || 
			// 	this.props.servicesInCart === BUNDLE.DATA_PHONE
			// )){
			// 	this.props.enableTheInternetNotification(true)
			// const routerCheck = document.getElementById('internetContinue');
			// routerCheck.scrollIntoView({block: "center", behavior: "smooth"});
			// return;
			// }
		if(!this.props.nfIsRouterSelected && (this.props.servicesInCart === BUNDLE.DATA || this.props.servicesInCart === BUNDLE.DATA_BDV)){
			this.props.enableRouterNotification(true)
			const routerCheck = document.getElementById('routerContinue');
			routerCheck.scrollIntoView({block: "center", behavior: "smooth"});
		}else if(this.props.nfIsRouterSelected && !this.props.isInternetFlowCompleted){
			this.props.enableRouterNotification(true)
			const routerCheck = document.getElementById('routerContinue');
			routerCheck.scrollIntoView({block: "center", behavior: "smooth"});
		}else if((this.props.servicesInCart === BUNDLE.DATA_BDV) && !this.props.serviceReqCheck && this.props.nfIsRouterSelected && !this.props.enableBDVW){
			this.props.enablePhoneNotification(true)
			setTimeout(()=>{
			const phoneCheck = document.getElementById('phoneContinue');
			phoneCheck.scrollIntoView({block: "center", behavior: "smooth"});
		},800);
		}else if((this.props.servicesInCart === BUNDLE.BDV) && !this.props.serviceReqCheck && !this.props.enableBDVW){
			this.props.enablePhoneNotification(true)
			setTimeout(()=>{
			const phoneCheck = document.getElementById('phoneContinue');
			phoneCheck.scrollIntoView({block: "center", behavior: "smooth"});
		},800);
		}else if((this.props.servicesInCart === BUNDLE.BDV || this.props.servicesInCart === BUNDLE.DATA_BDV) && this.props.serviceReqCheck && equipmentList && !this.props.enableBDVW){
			this.props.enableEquipmentNotification(true)
			setTimeout(()=>{
			const equipmentCheck = document.getElementById('phoneContinue');
			equipmentCheck.scrollIntoView({block: "center", behavior: "smooth"});
			},800);
		}else{
			SiteAnalytics.trackContractSeletion(this.props.selectedContract);
			SiteAnalytics.trackCheckoutBtnClick();
			if(this.props.enableDigitalLink !== 'Y') this.props.setCheckOutProgress("N")
				this.props.resetCheckoutNew()
				this.props.updateNextButtonCC("")
				this.props.setCompletedSections([])
			let path = (this.props.enableDigitalLink && this.props.enableDigitalLink === 'Y') ? '/save-cart' : '/checkout';
			this.props.history.push(path);
		}
	}
	}else{
		this.props.setfeatureSectionNotVisitedNotification(true);
	}
	};

	componentWillUnmount() {
		window.removeEventListener('scroll', () => { });
	}

	internetSpeedPrice = () => {
		const { serviceOrder } = this.props;
		let price =
			serviceOrder && serviceOrder?.length && serviceOrder[0].selectedDetails && Object.keys(serviceOrder[0].selectedDetails)?.length
				? serviceOrder[0].selectedDetails.BundleRC
				: (serviceOrder && serviceOrder?.length && serviceOrder[0].selectedPrice ? serviceOrder[0].selectedPrice : null);
		price = parseInt(price?.toString(), 10);
		let totalAmount = price ? price.toFixed(2) : '';
		return Number(totalAmount);
	};

	getInternetCommonPrice = (position) => {

		const { serviceOrder } = this.props;
		let price;
		if (serviceOrder?.length) {
			if (serviceOrder[position].selectedDetails?.length) {
				price = serviceOrder[position].selectedDetails.reduce((addition, eachDetail) => {
					return addition + parseInt(eachDetail.PrdPrice);
				}, 0);
			} else if (Object.keys(serviceOrder[position].selectedDetails)?.length && serviceOrder[position].selectedDetails.value !== "Dynamic IP") {
				price = serviceOrder[position].selectedDetails.PrdPrice;
				if (serviceOrder[position].selectedDetails.PrdSubCat === 'ROUTERNRCBILLER') { price = Number.parseFloat(price) / 3 };
				if (price === "INCLUDED") price = null;
			} else if (serviceOrder[position].selectedPrice) {
				price = serviceOrder[position].selectedPrice;
				if (price === "INCLUDED") price = null;
			} else {
				price = null;
			}
		}
		//let totalAmount = price ? parseInt(price).toFixed(2) : '';
		let totalAmount = price ? parseFloat(price).toFixed(2) : '';
		return Number(totalAmount);
	};

	getTvPrice = (position) => {
		const { tvOrder } = this.props;
		if (tvOrder?.length) {
			return tvOrder[position]?.selectedPrice ? tvOrder[position]?.selectedPrice : 0;
		}
	}

	componentWillUpdate(nextProps) {
		// Cart price calculations
		const cartPrice = nextProps.cartFmonthPrice && nextProps.cartFmonthPrice > 0 ? nextProps.cartFmonthPrice : 0;
		const isCartPriceSet = cartPrice > 0;

		// Phone price calculations
		// const phoneValue = this.getPhonePrice();
		// const cartValue = this.getCartValue();
		// const equipmentValue = this.calculateEquipment();
		// const standardPhonePrice = this.getStandardPhonePrice();
		// const directoryListingPrice = this.getDirectoryListingPrice();
		// const powerReserveValue = this.getPowerReserveValue();
		// const phoneTotal = nextProps.phoneSetupComplete && isCartPriceSet ? 0 : phoneValue + cartValue + standardPhonePrice + equipmentValue + directoryListingPrice + powerReserveValue;

		// Internet price calculations
		// const internetSpeedPrice = this.internetSpeedPrice();
		// const ipAddressPrice = this.getInternetCommonPrice(1);
		// const routerPrice = this.getInternetCommonPrice(1);
		// const securityPrice = this.getInternetCommonPrice(1);
		//const internetTotal = nextProps.internetComplete && isCartPriceSet ? 0 : internetSpeedPrice + (ipAddressPrice ? ipAddressPrice - internetSpeedPrice : ipAddressPrice) + routerPrice + securityPrice;

		// TV price calculations
		// const tvPlanPrice = this.getTvPrice(1);
		// const tvPremiumPrice = this.getTvPrice(2);
		// const tvEquipmentPrice = this.getTvPrice(3);
		// const tvRecordingPrice = this.getTvPrice(4);
		// const tvRouterPrice = this.getTvPrice(5);
		//const tvTotal = nextProps.tvComplete && isCartPriceSet ? 0 : (tvPlanPrice + tvPremiumPrice + tvEquipmentPrice + tvRecordingPrice + tvRouterPrice) / 100;
		// exixting...
		// const priceExpression = !(cartPrice + phoneTotal + internetTotal + tvTotal) ? '$0/mo' : `$${(cartPrice + phoneTotal + internetTotal + tvTotal).toFixed(2)}/mo`;
		// if (nextProps.navHeaderPrice !== priceExpression) {
		// 	this.props.setNavPrice(priceExpression);
		// }

		// const priceExpression = !(cartPrice) ? '$0/mo' : `$${(cartPrice).toFixed(2)}/mo`;
		// if (nextProps.navHeaderPrice !== priceExpression) {
		// 	this.props.setNavPrice(priceExpression);
		// }

		const { getFloatCartResponse } = nextProps;
		if (getFloatCartResponse) {
			let cartAmount = getFloatCartResponse?.planDetails?.headerInfo?.Price;
			const priceExpression = !(cartAmount) ? '$0/mo' : `${cartAmount}/mo`;
			this.props.setNavPrice(priceExpression);
			SiteAnalytics.trackCartSummaryPrice({ cartSummaryPrice: !(cartAmount) ? '0.00' : cartAmount });
		} else {
			this.props.setNavPrice('$0/mo');
			SiteAnalytics.trackCartSummaryPrice({ cartSummaryPrice: "0.00" });
		}
	}

	isRentRouterSelectedFun() {
		const { getFloatCartResponse } = this.props;
		let isRentRouterSelected = false;
		if (getFloatCartResponse && getFloatCartResponse.planDetails && getFloatCartResponse.planDetails.otherServices) {
			let rentPlanIndex = getFloatCartResponse.planDetails.otherServices.findIndex(item => item?.Product.includes("Rent"));
			if (rentPlanIndex > -1) {
				isRentRouterSelected = true;
			} else if (getFloatCartResponse?.planDetails?.equipmentAndOnetimeCharges && this.props.nfInternetType == 'DSL') {
				let rentPlanIndex = getFloatCartResponse.planDetails.equipmentAndOnetimeCharges.findIndex(item => item?.offerName.includes("Router"));
				if (rentPlanIndex > -1) {
					isRentRouterSelected = true;
				}
			}
		}
		return isRentRouterSelected;
	}

	checkRouterSelected(bundle) {
		const { selectedProductsResp } = this.props;
		if (this.props.pageLoadType === 'R' && selectedProductsResp && selectedProductsResp[bundle] && selectedProductsResp[bundle].Routers) {
			const selectedRouter = selectedProductsResp[bundle].Routers.filter(r => r.IsSelected);
			return selectedRouter?.length > 0;
		}
		return false;
	}

	showCheckOut() {
		let flag = true;
		let isInternetChecked = this.props.selectedBundleOptionsProducts.join('').indexOf('internet') > -1;
		let isPhoneChecked = this.props.selectedBundleOptionsProducts.indexOf('phone') > -1;
		let isTvChecked = this.props.isTvChecked;
		// let is911Accepted = this.props.Is911ServiceAccepted != "" ? true:false;

		const { getFloatCartResponse, nfEquipmentType, tvOrder, nfTvHdSetup } = this.props;
		const isRouterFromRetrieve = this.props.pageLoadType === 'R' && this.props.DataInfoResp && this.props.DataInfoResp?.Routers && this.props.DataInfoResp?.Routers.length && this.props.DataInfoResp?.Routers?.filter(r => r.IsSelected)?.length > 0;

		if (isInternetChecked && !isPhoneChecked && !isTvChecked) {
			// For Rent:
			let isRentRouterSelected = this.isRentRouterSelectedFun();
			if (nfEquipmentType || isRentRouterSelected || this.props.nfIsRouterSelected  || isRouterFromRetrieve) {
				flag = true;
			} else {
				flag = false;
			}
			if(tvOrder && tvOrder.length && tvOrder[0].selectedDetails && tvOrder[0].selectedDetails?.value && tvOrder[1].selectedDetails && tvOrder[1].selectedDetails?.value){
				flag = (tvOrder[2].selectedDetails?.value && tvOrder[2]?.continueClicked)  || false
			}
		} else if (!isInternetChecked && isPhoneChecked && !isTvChecked) {
			flag = !!this.props.nfPhoneFlowComplete;
		} else if (!isInternetChecked && !isPhoneChecked && isTvChecked) {
			flag = this.props.isTvComplete();
		} else if (isInternetChecked && isPhoneChecked && !isTvChecked) {
			let isRentRouterSelected = this.isRentRouterSelectedFun();
			if (nfEquipmentType || isRentRouterSelected || this.props.nfIsRouterSelected) {
				flag = true;
			} else {
				flag = false;
			}
			
			const listingFormElement = document.getElementById('listingform');
		let listing =  this.props.listingInfo && this.props.listingInfo.length >0 &&this.props.listingInfo[0].Name == 'Listing'? true:false;
			flag = !this.props.nfPhoneFlowComplete || (listing && listingFormElement) ? false : flag;
			//flag = !this.props.nfNoOfLinesSet && this.props.pageLoadType === 'C' && this.props.selectedBundleOptionsProducts?.length >= 2 ? false: flag
			if(tvOrder && tvOrder.length && tvOrder[0].selectedDetails && tvOrder[0].selectedDetails?.value && tvOrder[1].selectedDetails && tvOrder[1].selectedDetails?.value){
				flag = (tvOrder[2].selectedDetails?.value && tvOrder[2]?.continueClicked)  || false
			}
		} else if (isInternetChecked && !isPhoneChecked && isTvChecked) {
			let isRentRouterSelected = this.isRentRouterSelectedFun();
			if (nfEquipmentType || isRentRouterSelected || this.props.nfIsRouterSelected || this.checkRouterSelected('FlexInfo')) {
				flag = true;
			} else {
				flag = false;
			}
			let tvflag = this.props.isTvComplete();
			flag = !tvflag ? false : flag;
		} else if (isInternetChecked && isPhoneChecked && isTvChecked) {
			let isRentRouterSelected = this.isRentRouterSelectedFun();
			// let checkRouterSelected = this.checkRouterSelected('BDVFIOSTP')
			if (nfEquipmentType || isRentRouterSelected || this.props.nfIsRouterSelected || this.checkRouterSelected('BDVFIOSTP')) {
				flag = true;
			} else {
				flag = false;
			}
			flag = !this.props.nfPhoneFlowComplete ? false : flag;
			let tvflag = this.props.isTvComplete();
			flag = !tvflag ? false : flag;
			//	flag = !this.props.nfNoOfLinesSet && this.props.pageLoadType === 'C' && this.props.selectedBundleOptionsProducts?.length >= 2 ? false: flag; 
		}
		return flag;
	}


	render() {
		let { children, hideCart, servicesInCart, allSelectedNonDoBundlePlans, isBundleOffersFlow, isFlowChanged, hidePrice, getFloatCartResponse, checkEquipmentAdded } = this.props;
		const { opened } = this.state;
		const { globalscope, setNavPrice, resetContract, history } = this.props;
		const { location } = history || {};
		const disableCheckout = (this.showCheckOut());
		const disableCheckoutOn911Service = servicesInCart === BUNDLE.BDV ? this.props.serviceReqCheck == false ? true : false :
		servicesInCart === BUNDLE.DATA_BDV ? this.props.serviceReqCheck == false ? true : false : servicesInCart === BUNDLE.BDV_DATA_VIDEO ? this.props.serviceReqCheck == false ? true : false : false;
		let cartAmount = getFloatCartResponse?.planDetails?.headerInfo?.Price;
		const bundleCheckout = ((disableCheckout && disableCheckoutOn911Service)  || checkEquipmentAdded || this.props.savedCartError  || !this.props.nfIsRouterSelected || !disableCheckoutOn911Service || !disableCheckout);
		// let offerAmount = getFloatCartResponse?.planDetails?.offerInfo ? getFloatCartResponse?.planDetails?.offerInfo[0]?.planName : '';
		const navHeaderPrice = !(cartAmount) ? '$0/mo' : `${cartAmount}/mo`;
		const selectedTVPlanId=this.props?.tvViewType?.value;
		let isVcgCmpDirect = false;
		if(this.props?.isCOP){
			let showVcgSwitcher = CheckAEMBoolValue(this.props.t("fios.showVcgSwitcher", { ns: "fios"}));
			let showLobSwitcherfios = CheckAEMBoolValue(this.props.t("fios.showLobSwitcherfios", { ns: "fios"}));
			let vcgCmpSwitcherList = this.props.t("fios.vcgCmpSwitcherList", { ns: "fios",returnObjects:true })
			let isResidentialAddr = showLobSwitcherfios ? (this.props?.selectedStreetAddress?.propertyType === "R" || this.props?.residential === "true") ? true : false : false;
			let isCmpMatched = showVcgSwitcher && vcgCmpSwitcherList && Array.isArray(vcgCmpSwitcherList) && vcgCmpSwitcherList.some(cmp => decodeURIComponent(this.props?.cmp) === cmp) ? true : false;
			let showLobSwitcher = (isResidentialAddr || isCmpMatched) ? true : false;
			isVcgCmpDirect = showLobSwitcher ? true : false;
		}
		
		return (

			<div id='header-container' ref={(r) => this.stickyNav = r}>
				{isVcgCmpDirect && this.props?.isCOP ?<VcgBannerHeader cmp={this.props?.cmp}/>:<></>}
				
				<NavStickyHeader stuck={true} offset={this.state.stickyPos}>
					<div className="NavHeader">
						<div className="Top-Bar">
							{!isMobileOnly && <RenderAddress globalScope={globalscope} props={this.props}
								changeLinkHandler={(redirectUrl) => {
									this.setState({ showRedirectModal: true, redirectUrl });
								}}
							/>}
							{
								this.state.showRedirectModal && <ChangeAddressModal {...this.props} closeModal={() => { this.setState({ showRedirectModal: false }) }} redirectUrl={this.state.redirectUrl} />
							}
							<div ref={(ref) => (this.priceBlock = ref)}>
								<div className="Right-Sec">
									{/*<div className="checkout-btn">
										{location && location.pathname.indexOf('customize') > -1 && <Button primary size="small" onClick={this.btnHandler} disabled={disableCheckout || checkEquipmentAdded || this.props.savedCartError || this.props.isCheckoutEnableBDV} >Continue</Button>}
									</div>*/}
									<div className="checkout-btn">
									{this.props.enableBDVW ? 
									location && location.pathname?.indexOf('customize') > -1 && <Button primary size="small" onClick={
										(servicesInCart === BUNDLE.DATA_BDV ? bundleCheckout : (servicesInCart === BUNDLE.DATA || servicesInCart === BUNDLE.DATA_BDV) ? 
										(disableCheckout || checkEquipmentAdded || this.props.savedCartError || disableCheckoutOn911Service || !this.props.nfIsRouterSelected) : (disableCheckout && disableCheckoutOn911Service)  || checkEquipmentAdded || this.props.savedCartError || this.props.isCheckoutEnableBDV || !disableCheckoutOn911Service || !disableCheckout)  && this.btnHandler} >Continue</Button>
									: location && location.pathname?.indexOf('customize') > -1 && <Button primary size="small" onClick={
										(servicesInCart === BUNDLE.DATA_BDV ? bundleCheckout : (servicesInCart === BUNDLE.DATA || servicesInCart === BUNDLE.DATA_BDV) ? 
										(disableCheckout || checkEquipmentAdded || this.props.savedCartError || disableCheckoutOn911Service || !this.props.nfIsRouterSelected) : (disableCheckout && disableCheckoutOn911Service)  || checkEquipmentAdded || this.props.savedCartError || this.props.isCheckoutEnableBDV || !disableCheckoutOn911Service || !disableCheckout)  && this.btnHandler} >Continue</Button>}
									</div>
									<div className={`${hideCart ? "hideCart" : ""} save-cart-btn`}>
										{this.props.validateTos && <div className="submit-btn"><Button size="small" onClick={this.props.validateTos} disabled={this.props.isNoSsnChecked}>
											Submit order
      									</Button></div>}

										{/* <Button secondary size="small" disabled={this.props.savedCartError} onClick={this.redirectToSavecart}>
											Save cart
      									</Button> */}
									</div>

									<div className={`${hidePrice ? "hideCart" : ""} price-block`} onClick={this.toggleBox}>
										<Loader active={this.props.floatingCartLoader} />

										{!this.props.savedCartError && <span className="price-title">
											<Title size="large" primitive="h2">{navHeaderPrice}</Title>
											<TextLink>View price breakdown</TextLink>
											{/* <span>
															<Body size="small" bold primitive="h3">
																{offerAmount ? offerAmount : ''}
															</Body>
														</span> */}
										</span>
										}
										{isMobileOnly && !this.props.savedCartError &&
											<span className="arrow-icon">
												{this.state.opened &&
													<Icon name="close" size="medium" />
												}
												{!this.state.opened &&
													<Icon name="caret-down" size="medium" />
												}

												{/* <span className="over-triangle"></span> */}
											</span>
										}

										{!isMobileOnly && !this.props.savedCartError &&
											<span className="arrow-icon">
												<Icon name="caret-down" size="medium" />
												{/* <span className="over-triangle"></span> */}
											</span>
										}

									</div>

								</div>
							</div>
						</div>
						{/*this.props.addressQualificationDetails && this.props.addressQualificationDetails.LQPost && this.props.addressQualificationDetails.LQPost.Is_BaltimoreDCzipcode =="Y" && <Countdown/>*/}
						{opened && (
							<div className="boxContent" id="cart-open">
								{this.props.enableVDS3 ? 
<BundleFloatingCartNew checkoutPage={this.props.checkoutPage} selectedTab={this.props.selectedTab} servicesInCart={this.props.servicesInCart} selectedTVPlanId={selectedTVPlanId} resetTVSubHeaderCall={this.props?.resetTVSubHeaderCall} resetTvAddonsSection={this.props?.resetTvAddonsSection} navHeaderPrice={navHeaderPrice} history={this.props.history} practiceLeftX={this.state.priceBlockX}
cartToggle={()=>this.setState({opened:false})}
								 redirectToSavecart={this.redirectToSavecart}  savedTVPlanProductId={this.props?.savedTVPlanProductId} addressQualificationDetails={this.props.addressQualificationDetails} cmpCodeQueryParam={this.props.cmpCodeQueryParams}/>
									:
<BundleFloatingCart checkoutPage={this.props.checkoutPage} selectedTab={this.props.selectedTab} servicesInCart={this.props.servicesInCart} selectedTVPlanId={selectedTVPlanId} resetTVSubHeaderCall={this.props?.resetTVSubHeaderCall} resetTvAddonsSection={this.props?.resetTvAddonsSection} navHeaderPrice={navHeaderPrice} history={this.props.history} practiceLeftX={this.state.priceBlockX}
								 redirectToSavecart={this.redirectToSavecart}  savedTVPlanProductId={this.props?.savedTVPlanProductId} addressQualificationDetails={this.props.addressQualificationDetails} cmpCodeQueryParam={this.props.cmpCodeQueryParams}/>}

							</div>
							//<DynamicCart />
						)}
					</div >
					<HolidayOfferBanner/>
				</NavStickyHeader>
				{isMobileOnly && <RenderAddress globalScope={globalscope} props={this.props} changeLinkHandler={(redirectUrl) => {
					this.setState({ showRedirectModal: true, redirectUrl });
				}} />}
			</div>
		);
	}
}
NavHeader.defaultProps = {
	hideCart: false
}
const mapStateToProps = state => {
	const { CustomizeOrder, ReviewOrderPage, FloatingCart, CheckoutPage, AddressValidationPage } = state;
	return {
		cmpCodeQueryParams: AddressValidationPage?.cmpCodeQueryParams,
		accordionOpenStatus: CheckoutPage.accordionOpenStatus,
		isFlowChanged: CustomizeOrder.isFlowChanged,
		navHeaderPrice: CustomizeOrder.navHeaderPrice,
		// for bundle
		servicesInCart: CustomizeOrder.servicesInCart,
		isBundleOffersFlow: CustomizeOrder.isBundleOffersFlow,
		getFloatCartResponse: CustomizeOrder.getFloatCartResponse,
		cartFmonthPrice: ReviewOrderPage.cartFmonthPrice,
		allSelectedNonDoBundlePlans: CustomizeOrder.allSelectedNonDoBundlePlans,
		nfPhoneFlowComplete: CustomizeOrder.nfPhoneFlowComplete,
		selectedBundleOptionsProducts: CustomizeOrder.selectedBundleOptionsProducts,
		floatingCartLoader: FloatingCart.floatingCartLoader,
		nfIsRouterSelected: CustomizeOrder.nfIsRouterSelected,
		phoneNumber: AddressValidationPage.phoneNumber,
		VOStatus: AddressValidationPage.VOStatus,
		nfEquipmentType: CustomizeOrder.nfEquipmentType,
		savedCartError: CheckoutPage.savedCartError,
		selectedProductsResp: CustomizeOrder.selectedProductsResp,
		pageLoadType: CustomizeOrder.pageLoadType,
		isCheckoutPageVisited: CustomizeOrder.isCheckoutPageVisited,
		nfInternetType: CustomizeOrder.nfInternetType,
		nfNoOfLinesSet: CustomizeOrder.nfNoOfLinesSet,
		techTeamFormData: CustomizeOrder.techTeamFormData,
		showTechTeamFrm: CustomizeOrder.showTechTeamFrm,
		checkEquipmentAdded: CustomizeOrder.checkEquipmentAdded,
		serviceReqCheck: CustomizeOrder.serviceReqCheck,
		isBDVBundle: CustomizeOrder.isBDVBundle,
		isCheckoutEnableBDV: CustomizeOrder.isCheckoutEnableBDV,
		Is911ServiceAccepted : CustomizeOrder.Is911ServiceAccepted,		
		nfTvHdSetup: CustomizeOrder.nfTvHdSetup,
		// isCheckoutEnableBDV: CustomizeOrder.isCheckoutEnableBDV,
		// Is911ServiceAccepted : CustomizeOrder.Is911ServiceAccepted,
		nfTechTeamSelected : CustomizeOrder.nfTechTeamSelected,
		nfTechTeamSubmitted : CustomizeOrder.nfTechTeamSubmitted,
		listingInfo : FloatingCart.listingInfo,
		tvViewType:CustomizeOrder?.tvViewType,
		isSaveBusinessInfo: CheckoutPage.isSaveBusinessInfo,
        addressQualificationDetails: AddressValidationPage?.addressQualificationDetails,
		bdvEquipmentList: CustomizeOrder.bdvEquipmentList,
		isInternetFlowCompleted: CustomizeOrder.isInternetFlowCompleted,
		enableFeaturesBDVW: CustomizeOrder.enableFeaturesBDVW,
		enableEquipmentBDVW: CustomizeOrder?.enableEquipmentBDVW,
		enableWebexSection: CustomizeOrder?.enableWebexSection,
		bdvwFeaturesVisited: CustomizeOrder?.bdvwFeaturesVisited,
		selectedRouter: CustomizeOrder.newRouterSelected,
		selectedInternetPlanID:CustomizeOrder.selectedInternetPlanID,
		cmp: CustomizeOrder?.cmp,
		selectedStreetAddress: AddressValidationPage?.selectedStreetAddress,
		residential: CustomizeOrder?.residential,
	}
}
const mapDispatchToProps = (dispatch) => ({
	setCompletedSections: (data) => dispatch(setCompletedSections(data)),
	setNavPrice: (data) => dispatch(setNavPrice(data)),
	setCheckOutProgress: (data) => {dispatch(setCheckOutProgress(data)); },
	postUIEventLog: (data) => dispatch(postUIEventLog(data)),
	showSpinner: (data) => dispatch(showSpinner(data)),
	saveBusinessInfo: (data) => dispatch(saveBusinessInfo(data)),
	enableRouterNotification: (data) => dispatch(enableRouterNotification(data)),
	enablePhoneNotification: (data) => dispatch(enablePhoneNotification(data)),
	enableEquipmentNotification: (data) => dispatch(enableEquipmentNotification(data)),
	setRouterErrorNotification: (data)=>dispatch(setRouterErrorNotification(data)),
	resetCheckoutNew: ()=>dispatch(resetCheckoutNew()),
	updateNextButtonCC: (data)=>dispatch(updateNextButtonCC(data))
	// enableTheInternetNotification:(data)=>dispatch(enableTheInternetNotification(data))

})

NavHeader = connect(mapStateToProps, mapDispatchToProps)(NavHeader);

export default NavHeader;
